import { ReactNode } from "react";

export const getErrorMessages = (error: any, errorTitle: string) => {
  const data = error.response.data;

  const { errors } = data;

  if (errors) {
    const keys = Object.keys(errors);

    const errorMessages = new Set<string>();

    keys.forEach((key: string) => {
      errors[key].forEach((item: string) => {
        errorMessages.add(item);
      });
    });

    const message: ReactNode = (
      <div>
        {errorTitle}
        <ul className="mt-2 pl-1 mb-0">
          {Array.from(errorMessages).map((item: string, i: number) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    );

    return message;
  }

  return data.title;
};
